import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { HouseSvg } from './svg/house';

export const HouseIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HouseSvg} {...props} />
);
